export default __webpack_public_path__ + "static/media/juniorGraphicDesigner.95d6daf1.png";